import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_SETTINGS = {
  app_name: "Sama Écoute",
  contact_email: "balcathy10@gmail.com",
  contact_phone: "",
  contact_location: "Sénégal & Diaspora — Disponible",
  whatsapp_number: "15142389008",
};

const SettingsContext = createContext({
  settings: DEFAULT_SETTINGS,
  refresh: () => {},
});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings((s) => ({ ...s, ...data }));
    } catch (e) { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
